import { useWSMutation } from "@ws-react-query";
import { updateInsuranceImport } from "../../../services/api/insurance/import/updateInsuranceImport";
import type { insuranceImportApiSpec } from "@wingspanhq/wingspan-api-types";
import { QUERY_INSURANCE_IMPORT } from "../keys";

export const useMutationUpdateInsuranceImport = () => {
  return useWSMutation(
    ({
      insuranceImportId,
      request
    }: {
      insuranceImportId: string;
      request: insuranceImportApiSpec.InsuranceImportUpdateRequest;
    }) => {
      return updateInsuranceImport(insuranceImportId, request);
    },
    {
      dependencies: [QUERY_INSURANCE_IMPORT]
    }
  );
};
